import { useEffect, useState } from "react";
import { IMG } from "../data/site";
import { PageHero, Section, Overline, Btn } from "../components/site/bits";
import { Stagger, StaggerItem } from "../components/site/motion";
import { MapPin, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Careers() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { fetch(`${API}/careers`).then((r) => r.json()).then(setJobs).catch(() => setJobs([])); }, []);
  return (
    <>
      <PageHero overline="Careers" lines={["Do work that", "matters."]} image={IMG.office}
        intro="Join a team driven by lived experience and a shared belief in second chances. Explore our vacancies, placements and volunteering opportunities." />
      <Section>
        <Overline>Current opportunities</Overline>
        <Stagger key={jobs.length} className="mt-10 divide-y divide-brand-dark/10 border-y border-brand-dark/10">
          {jobs.map((j) => (
            <StaggerItem key={j.id}>
              <div className="group flex flex-col gap-4 py-8 md:flex-row md:items-center md:justify-between">
                <div>
                  <span className="text-xs font-semibold uppercase tracking-wider text-brand-green">{j.type}</span>
                  <h3 className="mt-2 font-serif text-2xl text-brand-dark md:text-3xl">{j.title}</h3>
                  <p className="mt-2 max-w-2xl text-sm text-brand-slate">{j.summary}</p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-brand-slate/70">
                    <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{j.location}</span>
                    <span>{j.contract}</span>
                  </div>
                </div>
                <Btn to="/contact" variant="outline" testid={`career-apply-${j.id}`}>Apply</Btn>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
        <div className="mt-16 rounded-3xl bg-brand-green p-10 text-white md:p-14">
          <h2 className="font-serif text-3xl md:text-4xl">Don't see the right role?</h2>
          <p className="mt-4 max-w-xl text-white/85">We're always keen to hear from passionate people. Send us your CV and tell us how you'd like to make a difference.</p>
          <div className="mt-8"><Btn to="/contact" variant="light" testid="careers-cta">Send speculative application</Btn></div>
        </div>
      </Section>
    </>
  );
}
